import React from 'react'
import SEO from '../../../common/SEO'
import Layout from '../../../common/Layout'
import BreadcrumbOne from '../../../common/breadcrumb/BreadcrumbOne'
import StencilBox from '../../stencils/StencilBox'
import { Link } from 'react-router-dom'
import KnowledgeCardStencil from './KnowledgeCardStencil'

function KnowledgeCardAllStencil({ data }) {
    return (
        <>

            <SEO title="Salesforce Knowledge Card | Longswitch Academy" /> {/* Set SEO title */}
            <Layout>
                <BreadcrumbOne
                    title="Salesforce Knowledge Card" // Breadcrumb title
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Salesforce Knowledge Card"
                />
                <div className="edu-pricing-area edu-section-gap bg-image mb--20">
                    <div className="container edu-section-pricing-gapBottom">
                        <div className="row y-gap-15 g-5">
                            <div className="col-lg-5">
                                <div className="section-title text-start">
                                    <StencilBox
                                        className="pre-title stencil-sm-devic mb--10"
                                        width="50%"
                                        height="26px"
                                        backgroundColor="#F5F5F5"
                                    />
                                    <StencilBox
                                        className="pre-title stencil-sm-devic"
                                        width="90%"
                                        height="56px"
                                        backgroundColor="#F5F5F5"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-7">
                                <div className="button-group isotop-filter filters-button-group d-flex justify-content-start justify-content-lg-end">
                                    <Link className="edu-btn-stencil">
                                        <StencilBox
                                            className="sf-blog-btn-stencil"
                                            width="223px"
                                            height="60px"
                                            backgroundColor="#F5F5F5"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="row  y-gap-15 g-5 mt--10 text-center">
                            {(data || [])?.map((item) => (
                                <div key={item?.id} className="col-12 col-xl-4 col-lg-4 d-flex justify-content-center">
                                    <KnowledgeCardStencil />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default KnowledgeCardAllStencil
